import { UserGroupHttpClient } from 'module/api/user-group';
import { axiosInstance } from '../axios';

export const UserGroupAPI = new UserGroupHttpClient(axiosInstance);
